import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-g-no-circle--sprite",
  "use": "google-g-no-circle--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"google-g-no-circle--sprite\">\n<path d=\"M21.8047 10.041H21V10H12V14H17.6523C16.8262 16.3281 14.6113 18 12 18C8.68555 18 6 15.3145 6 12C6 8.68555 8.68555 6 12 6C13.5293 6 14.9219 6.57617 15.9805 7.51953L18.8086 4.69141C17.0234 3.02734 14.6348 2 12 2C6.47656 2 2 6.47656 2 12C2 17.5234 6.47656 22 12 22C17.5234 22 22 17.5234 22 12C22 11.3301 21.9316 10.6758 21.8047 10.041Z\" fill=\"#333333\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol